import { getTenant } from '../../../theme/tokens'
export const MALAYSIAN_STATES = [
  'Kuala Lumpur',
  'Selangor',
  'Penang',
  'Johor',
  'Perak',
  'Kedah',
  'Kelantan',
  'Terengganu',
  'Pahang',
  'Negeri Sembilan',
  'Malacca',
  'Perlis',
  'Sabah',
  'Sarawak',
  'Putrajaya',
  'Labuan',
]
export const MALAYSIAN_BANKS = [
  'Maybank',
  'CIMB Bank',
  'Public Bank',
  'RHB Bank',
  'Hong Leong Bank',
  'AmBank',
  'Bank Rakyat',
  'Bank Islam',
  'Affin Bank',
  'Alliance Bank',
  'OCBC Bank (Malaysia)',
  'HSBC Bank Malaysia',
  'Standard Chartered Malaysia',
  'UOB Malaysia',
  'Citibank Malaysia',
  'MBSB Bank',
  'Agrobank',
  'Bank Muamalat',
]
// Backwards-compatible aliases
export const THAI_PROVINCES = MALAYSIAN_STATES
export const THAI_BANKS = MALAYSIAN_BANKS
export interface Supplier {
  id: string
  supplierType: 'company' | 'individual'
  name: string
  email: string
  phone: string
  useAsBillingEmail: boolean
  addressLine1: string
  addressLine2: string
  city: string
  province: string
  country: string
  postcode: string
  internalReference: string
  taxId: string
  companyNameTh: string
  companyNameEn: string
  branch: string
  vatRegistered: boolean
  contactPerson: string
  idType: 'citizen_id' | 'passport' | ''
  idNumber: string
  fullNameTh: string
  fullNameEn: string
  individualTaxId: string
  payInMethod: 'acquiring' | 'card'
  cardholderName: string
  cardNumber: string
  expiryDate: string
  payoutMethod: 'bank_account' | 'promptpay'
  bankName: string
  accountNumber: string
  accountName: string
  promptPayType: 'phone' | 'citizen_id' | 'tax_id' | ''
  promptPayId: string
  promptPayName: string
  amountOwed: string
  source: string
  dateCreated: string
  isArchived: boolean
}
export const mockSuppliers: Supplier[] = [
  {
    id: '1',
    supplierType: 'company',
    name: 'Test Company Sdn Bhd',
    email: 'simon+supplier@maybank.com.my',
    phone: '0321234567',
    useAsBillingEmail: true,
    addressLine1: '123, Jalan Ampang',
    addressLine2: 'Taman Ampang Hilir',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50450',
    internalReference: 'SUP-001',
    taxId: '202301012345',
    companyNameTh: 'Test Company Sdn Bhd',
    companyNameEn: 'Test Company Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ahmad bin Ismail',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maybank',
    accountNumber: '0381236789',
    accountName: 'Test Company Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 9,393.00`,
    source: 'Pomelo',
    dateCreated: '13/03/2026, 12:26',
    isArchived: false,
  },
  {
    id: '2',
    supplierType: 'company',
    name: 'Premium Tea Estates Sdn Bhd',
    email: 'rajesh@premiumtea.my',
    phone: '0355559001',
    useAsBillingEmail: true,
    addressLine1: '88, Jalan Tun Razak',
    addressLine2: 'Bukit Bintang',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50400',
    internalReference: 'TEA-002',
    taxId: '201501001234',
    companyNameTh: 'Premium Tea Estates Sdn Bhd',
    companyNameEn: 'Premium Tea Estates Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Rajesh Kumar',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'CIMB Bank',
    accountNumber: '2554001289',
    accountName: 'Premium Tea Estates Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '10/01/2026, 09:15',
    isArchived: false,
  },
  {
    id: '3',
    supplierType: 'company',
    name: 'Packaging Solutions Sdn Bhd',
    email: 'john@packagingsolutions.my',
    phone: '0377778899',
    useAsBillingEmail: false,
    addressLine1: '45-12, Jalan SS15/4',
    addressLine2: 'Subang Jaya',
    city: 'Subang Jaya',
    province: 'Selangor',
    country: 'Malaysia',
    postcode: '47500',
    internalReference: 'PKG-003',
    taxId: '201801009876',
    companyNameTh: 'Packaging Solutions Sdn Bhd',
    companyNameEn: 'Packaging Solutions Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'John Tan',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Public Bank',
    accountNumber: '4081234567',
    accountName: 'Packaging Solutions Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 45,000.00`,
    source: 'Pomelo',
    dateCreated: '05/02/2026, 14:30',
    isArchived: false,
  },
  {
    id: '4',
    supplierType: 'individual',
    name: 'Mohd Faizal bin Hassan',
    email: 'faizal.h@gmail.com',
    phone: '0123456789',
    useAsBillingEmail: true,
    addressLine1: '99-5, Jalan Gasing',
    addressLine2: 'Petaling Jaya',
    city: 'Petaling Jaya',
    province: 'Selangor',
    country: 'Malaysia',
    postcode: '46000',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '850712-08-1234',
    fullNameTh: 'Mohd Faizal bin Hassan',
    fullNameEn: 'Mohd Faizal bin Hassan',
    individualTaxId: 'SG12345678901',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '0123456789',
    promptPayName: 'Mohd Faizal bin Hassan',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '12/04/2026, 11:20',
    isArchived: true,
  },
  {
    id: '5',
    supplierType: 'company',
    name: 'Malaysia Fresh Produce Sdn Bhd',
    email: 'procurement@msiafresh.com.my',
    phone: '0323456789',
    useAsBillingEmail: true,
    addressLine1: '222, Jalan Kuching',
    addressLine2: 'Segambut',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '51200',
    internalReference: 'FRESH-005',
    taxId: '201700004567',
    companyNameTh: 'Malaysia Fresh Produce Sdn Bhd',
    companyNameEn: 'Malaysia Fresh Produce Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Wan Norazlina binti Yusof',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'RHB Bank',
    accountNumber: '0621234567',
    accountName: 'Malaysia Fresh Produce Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 128,500.00`,
    source: 'Pomelo',
    dateCreated: '20/05/2026, 08:45',
    isArchived: false,
  },
  {
    id: '6',
    supplierType: 'company',
    name: 'KL Digital Print House',
    email: 'sales@kldigitalprint.com',
    phone: '0326789012',
    useAsBillingEmail: true,
    addressLine1: '15-3, Jalan Maarof',
    addressLine2: 'Bangsar',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '59000',
    internalReference: 'PRT-006',
    taxId: '201902003456',
    companyNameTh: 'KL Digital Print House Sdn Bhd',
    companyNameEn: 'KL Digital Print House Sdn Bhd',
    branch: '00001',
    vatRegistered: true,
    contactPerson: 'Lim Wei Ming',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Lim Wei Ming',
    cardNumber: '4111XXXXXXXX4242',
    expiryDate: '09/27',
    payoutMethod: 'bank_account',
    bankName: 'Hong Leong Bank',
    accountNumber: '0019876543',
    accountName: 'KL Digital Print House Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 22,750.00`,
    source: 'Manual entry',
    dateCreated: '03/01/2026, 16:10',
    isArchived: false,
  },
  {
    id: '7',
    supplierType: 'company',
    name: 'Eastern Logistics Group Sdn Bhd',
    email: 'accounts@easternlogistics.com.my',
    phone: '0738456789',
    useAsBillingEmail: true,
    addressLine1: '789, Jalan Tebrau',
    addressLine2: 'Taman Pelangi',
    city: 'Johor Bahru',
    province: 'Johor',
    country: 'Malaysia',
    postcode: '80250',
    internalReference: 'LOG-007',
    taxId: '201600008765',
    companyNameTh: 'Eastern Logistics Group Sdn Bhd',
    companyNameEn: 'Eastern Logistics Group Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Prakash Subramaniam',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'AmBank',
    accountNumber: '1234567890',
    accountName: 'Eastern Logistics Group Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 67,200.00`,
    source: 'Pomelo',
    dateCreated: '15/04/2026, 10:30',
    isArchived: false,
  },
  {
    id: '8',
    supplierType: 'individual',
    name: 'Nurul Aisyah binti Rahman',
    email: 'nurul.aisyah@hotmail.com',
    phone: '0182345678',
    useAsBillingEmail: true,
    addressLine1: '34-2, Lorong Cangkat Minden 9',
    addressLine2: 'Gelugor',
    city: 'George Town',
    province: 'Penang',
    country: 'Malaysia',
    postcode: '11700',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '900215-07-2347',
    fullNameTh: 'Nurul Aisyah binti Rahman',
    fullNameEn: 'Nurul Aisyah binti Rahman',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maybank',
    accountNumber: '7771234567',
    accountName: 'Nurul Aisyah binti Rahman',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 15,000.00`,
    source: 'Manual entry',
    dateCreated: '22/02/2026, 13:45',
    isArchived: false,
  },
  {
    id: '9',
    supplierType: 'company',
    name: 'Green Valley Agriculture Sdn Bhd',
    email: 'info@greenvalleyag.com.my',
    phone: '0544567890',
    useAsBillingEmail: true,
    addressLine1: '56, Jalan Sultan Idris Shah',
    addressLine2: 'Taman Anda',
    city: 'Ipoh',
    province: 'Perak',
    country: 'Malaysia',
    postcode: '30000',
    internalReference: 'AGR-009',
    taxId: '202000001122',
    companyNameTh: 'Green Valley Agriculture Sdn Bhd',
    companyNameEn: 'Green Valley Agriculture Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Kogilan Krishnan',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Agrobank',
    accountNumber: '0201234567',
    accountName: 'Green Valley Agriculture Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'API',
    dateCreated: '08/02/2026, 09:00',
    isArchived: false,
  },
  {
    id: '10',
    supplierType: 'company',
    name: 'Borneo Seafood Export Sdn Bhd',
    email: 'export@borneoseafood.com',
    phone: '0882234567',
    useAsBillingEmail: false,
    addressLine1: '12-8, Jalan Gaya',
    addressLine2: 'Pusat Bandar',
    city: 'Kota Kinabalu',
    province: 'Sabah',
    country: 'Malaysia',
    postcode: '88000',
    internalReference: 'SEA-010',
    taxId: '201400006543',
    companyNameTh: 'Borneo Seafood Export Sdn Bhd',
    companyNameEn: 'Borneo Seafood Export Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Anita Sulaiman',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Public Bank',
    accountNumber: '1119876543',
    accountName: 'Borneo Seafood Export Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 234,100.00`,
    source: 'Pomelo',
    dateCreated: '01/11/2025, 11:15',
    isArchived: false,
  },
  {
    id: '11',
    supplierType: 'company',
    name: 'KL Office Supplies Sdn Bhd',
    email: 'orders@klofficesupplies.com.my',
    phone: '0322223333',
    useAsBillingEmail: true,
    addressLine1: '300-1, Jalan Bukit Bintang',
    addressLine2: 'Bukit Bintang',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '55100',
    internalReference: 'OFF-011',
    taxId: '202100002233',
    companyNameTh: 'KL Office Supplies Sdn Bhd',
    companyNameEn: 'KL Office Supplies Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Sarah Lee Mei Ling',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Sarah Lee Mei Ling',
    cardNumber: '5500XXXXXXXX1234',
    expiryDate: '12/28',
    payoutMethod: 'bank_account',
    bankName: 'UOB Malaysia',
    accountNumber: '9881234567',
    accountName: 'KL Office Supplies Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 8,450.00`,
    source: 'Manual entry',
    dateCreated: '28/01/2026, 15:20',
    isArchived: false,
  },
  {
    id: '12',
    supplierType: 'individual',
    name: 'Tan Chee Wei',
    email: 'tan.cw@gmail.com',
    phone: '0167654321',
    useAsBillingEmail: true,
    addressLine1: '77, Jalan SS2/24',
    addressLine2: 'SS2',
    city: 'Petaling Jaya',
    province: 'Selangor',
    country: 'Malaysia',
    postcode: '47300',
    internalReference: 'FRL-012',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '880430-14-5678',
    fullNameTh: 'Tan Chee Wei',
    fullNameEn: 'Tan Chee Wei',
    individualTaxId: 'OG87654321010',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'citizen_id',
    promptPayId: '880430145678',
    promptPayName: 'Tan Chee Wei',
    amountOwed: `${getTenant().currency.code} 3,200.00`,
    source: 'Manual entry',
    dateCreated: '14/02/2026, 09:30',
    isArchived: false,
  },
  {
    id: '13',
    supplierType: 'company',
    name: 'Northern Textile Mills Sdn Bhd',
    email: 'sales@northerntextile.com.my',
    phone: '0457789012',
    useAsBillingEmail: true,
    addressLine1: '199, Jalan Sultanah Bahiyah',
    addressLine2: 'Bandar Alor Setar',
    city: 'Alor Setar',
    province: 'Kedah',
    country: 'Malaysia',
    postcode: '05000',
    internalReference: 'TXT-013',
    taxId: '201300007788',
    companyNameTh: 'Northern Textile Mills Sdn Bhd',
    companyNameEn: 'Northern Textile Mills Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Azman bin Othman',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'CIMB Bank',
    accountNumber: '0661234567',
    accountName: 'Northern Textile Mills Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 89,300.00`,
    source: 'Pomelo',
    dateCreated: '19/03/2026, 14:00',
    isArchived: false,
  },
  {
    id: '14',
    supplierType: 'company',
    name: 'Langkawi Coconut Products Sdn Bhd',
    email: 'info@langkawicoconut.com',
    phone: '0494456123',
    useAsBillingEmail: true,
    addressLine1: '33, Jalan Pantai Cenang',
    addressLine2: 'Mukim Kedawang',
    city: 'Langkawi',
    province: 'Kedah',
    country: 'Malaysia',
    postcode: '07000',
    internalReference: 'COC-014',
    taxId: '201900009900',
    companyNameTh: 'Langkawi Coconut Products Sdn Bhd',
    companyNameEn: 'Langkawi Coconut Products Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Haslinda binti Abdullah',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'tax_id',
    promptPayId: '201900009900',
    promptPayName: 'Langkawi Coconut Products Sdn Bhd',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'API',
    dateCreated: '05/12/2025, 10:00',
    isArchived: false,
  },
  {
    id: '15',
    supplierType: 'company',
    name: 'Metro Clean Services Sdn Bhd',
    email: 'billing@metroclean.com.my',
    phone: '0321112222',
    useAsBillingEmail: true,
    addressLine1: '55-9, Jalan Cheras',
    addressLine2: 'Taman Maluri',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '55100',
    internalReference: 'CLN-015',
    taxId: '201801005566',
    companyNameTh: 'Metro Clean Services Sdn Bhd',
    companyNameEn: 'Metro Clean Services Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ravi Maniam',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '0551234567',
    accountName: 'Metro Clean Services Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 18,900.00`,
    source: 'Manual entry',
    dateCreated: '11/05/2026, 08:30',
    isArchived: false,
  },
  {
    id: '16',
    supplierType: 'individual',
    name: 'Wong Pei Shan',
    email: 'wong.peishan@outlook.com',
    phone: '0145556789',
    useAsBillingEmail: true,
    addressLine1: '8-1, Jalan Setiawangsa 11',
    addressLine2: 'Taman Setiawangsa',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '54200',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'passport',
    idNumber: 'A12345678',
    fullNameTh: 'Wong Pei Shan',
    fullNameEn: 'Wong Pei Shan',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '0145556789',
    promptPayName: 'Wong Pei Shan',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '02/03/2026, 11:00',
    isArchived: false,
  },
  {
    id: '17',
    supplierType: 'company',
    name: 'East Coast Rice Trading Sdn Bhd',
    email: 'trade@eastcoastrice.com.my',
    phone: '0932234567',
    useAsBillingEmail: true,
    addressLine1: '120, Jalan Sultan Yahya Petra',
    addressLine2: 'Bandar Kota Bharu',
    city: 'Kota Bharu',
    province: 'Kelantan',
    country: 'Malaysia',
    postcode: '15000',
    internalReference: 'RICE-017',
    taxId: '201500004455',
    companyNameTh: 'East Coast Rice Trading Sdn Bhd',
    companyNameEn: 'East Coast Rice Trading Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Mohd Hafiz bin Ibrahim',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Islam',
    accountNumber: '4451234567',
    accountName: 'East Coast Rice Trading Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 156,000.00`,
    source: 'Pomelo',
    dateCreated: '25/01/2026, 13:15',
    isArchived: false,
  },
  {
    id: '18',
    supplierType: 'company',
    name: 'Pahang Rubber Industries Sdn Bhd',
    email: 'procurement@pahangrubber.com.my',
    phone: '0958901234',
    useAsBillingEmail: true,
    addressLine1: '88-3, Jalan Tun Ismail',
    addressLine2: 'Bandar Indera Mahkota',
    city: 'Kuantan',
    province: 'Pahang',
    country: 'Malaysia',
    postcode: '25200',
    internalReference: 'RBR-018',
    taxId: '201200003344',
    companyNameTh: 'Pahang Rubber Industries Sdn Bhd',
    companyNameEn: 'Pahang Rubber Industries Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Cheng Kok Wai',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Affin Bank',
    accountNumber: '8881234567',
    accountName: 'Pahang Rubber Industries Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 312,500.00`,
    source: 'API',
    dateCreated: '14/09/2025, 09:45',
    isArchived: false,
  },
  {
    id: '19',
    supplierType: 'company',
    name: 'Sarawak Tour Operators Sdn Bhd',
    email: 'finance@sarawaktours.com',
    phone: '0822678901',
    useAsBillingEmail: false,
    addressLine1: '5-2, Jalan Padungan',
    addressLine2: 'Pusat Bandar',
    city: 'Kuching',
    province: 'Sarawak',
    country: 'Malaysia',
    postcode: '93100',
    internalReference: 'TOUR-019',
    taxId: '201902008877',
    companyNameTh: 'Sarawak Tour Operators Sdn Bhd',
    companyNameEn: 'Sarawak Tour Operators Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Siti Rohani binti Daud',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Siti Rohani binti Daud',
    cardNumber: '4532XXXXXXXX8901',
    expiryDate: '03/28',
    payoutMethod: 'bank_account',
    bankName: 'Alliance Bank',
    accountNumber: '7771234567',
    accountName: 'Sarawak Tour Operators Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 41,600.00`,
    source: 'Pomelo',
    dateCreated: '28/02/2026, 16:30',
    isArchived: false,
  },
  {
    id: '20',
    supplierType: 'company',
    name: 'Old Warehouse Supplies Sdn Bhd',
    email: 'info@oldwarehouse.com.my',
    phone: '0324445555',
    useAsBillingEmail: true,
    addressLine1: '10, Jalan Petaling',
    addressLine2: 'Chinatown',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50000',
    internalReference: 'WH-020',
    taxId: '201100001100',
    companyNameTh: 'Old Warehouse Supplies Sdn Bhd',
    companyNameEn: 'Old Warehouse Supplies Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Manoj Patel',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maybank',
    accountNumber: '1231234567',
    accountName: 'Old Warehouse Supplies Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '18/05/2024, 10:00',
    isArchived: true,
  },
  {
    id: '21',
    supplierType: 'individual',
    name: 'Aminah binti Yaakub',
    email: 'aminah.y@yahoo.com',
    phone: '0193456789',
    useAsBillingEmail: true,
    addressLine1: '42-5, Jalan Hang Tuah',
    addressLine2: 'Banda Hilir',
    city: 'Malacca City',
    province: 'Malacca',
    country: 'Malaysia',
    postcode: '75000',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '780923-04-3456',
    fullNameTh: 'Aminah binti Yaakub',
    fullNameEn: 'Aminah binti Yaakub',
    individualTaxId: 'SG78092304345',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Public Bank',
    accountNumber: '4081239876',
    accountName: 'Aminah binti Yaakub',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 7,500.00`,
    source: 'Manual entry',
    dateCreated: '06/01/2026, 14:20',
    isArchived: false,
  },
  {
    id: '22',
    supplierType: 'company',
    name: 'Defunct Trading Sdn Bhd',
    email: 'old@defuncttrading.com',
    phone: '0321110000',
    useAsBillingEmail: true,
    addressLine1: '1, Jalan Tun H S Lee',
    addressLine2: 'City Centre',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50000',
    internalReference: 'DEF-022',
    taxId: '201000009999',
    companyNameTh: 'Defunct Trading Sdn Bhd',
    companyNameEn: 'Defunct Trading Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'N/A',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'MBSB Bank',
    accountNumber: '3331234567',
    accountName: 'Defunct Trading Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '01/03/2024, 08:00',
    isArchived: true,
  },
]
export interface InvitedSupplier {
  id: string
  name: string
  supplierType: 'company' | 'individual'
  inviteLink: string
  dateInvited: string
  daysAgo: number
}
export const mockInvitedSuppliers: InvitedSupplier[] = [
  {
    id: 'inv-1',
    name: 'Malaysia Fresh Market Sdn Bhd',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/a1b2c3d4e5',
    dateInvited: '14/02/2026, 10:30',
    daysAgo: 30,
  },
  {
    id: 'inv-2',
    name: 'Nazrin bin Suhaimi',
    supplierType: 'individual',
    inviteLink: '/supplier-onboarding/f6g7h8i9j0',
    dateInvited: '05/03/2026, 14:15',
    daysAgo: 11,
  },
  {
    id: 'inv-3',
    name: 'Malaysia Organic Produce Sdn Bhd',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/k1l2m3n4o5',
    dateInvited: '12/03/2026, 09:00',
    daysAgo: 4,
  },
]
